import { composeClassNames } from "@faedev/editor-utils";
import { useState } from "react";
import Content from "src/components/Content";
import PlatformCardsCompanies from "src/components/PlatformCardsCompanies";
import PlatformCardsMembers from "src/components/PlatformCardsMembers";
import SectionHeading from "src/components/SectionHeading";
import constants from "src/constants";
import { sPlatform } from "src/styles/sPlatform.module.scss";
import PlatformCardsInstructors from "./PlatformCardsInstructors";

type Props = {
  backgroundColor?: string;
  className?: (string | string) | null | undefined;
  specificContent: "members" | "instructors" | "companies" | "none";
  subtitle: string;
  title: string;
};

function Platform({
  backgroundColor,
  className,
  specificContent,
  subtitle,
  title,
}: Props) {
  const [activeContent, setActiveContent] = useState<
    "members" | "instructors" | "companies"
  >(specificContent !== "none" ? specificContent : "members");
  return (
    <Content
      style={{ background: backgroundColor || constants.Theme.white }}
      className={composeClassNames([sPlatform, className, "platform"])}
      fluid={`full`}
      verticalSpace={`lg`}
    >
      <div className="platform-wrapper">
        <SectionHeading align="center" subtitle={subtitle} title={title} />
        {activeContent === "members" && <PlatformCardsMembers />}
        {activeContent === "companies" && <PlatformCardsCompanies />}
        {activeContent === "instructors" && <PlatformCardsInstructors />}
      </div>
    </Content>
  );
}

export default Platform;
